<!--
 * @Description:
 * @Author: elliot_cj
 * @Date: 2019-01-11 11:35:34
 * @LastEditors: elliot_cj
 * @LastEditTime: 2019-01-18 17:01:33
 -->
<template>
    <PopupPanel
            :show="show"
            position="bottom"
            radius="5px"
            height="85%"
            type="map"
            title="请选择"
            right="确定"
            left="取消"
            @panel="panelClick"
    >
        <el-amap
                :zoom="18"
                class="amap-box"
                :plugin="plugin"
                :center="center"
                :events="{ click: mapClick }"
        >
            <el-amap-marker
                    :draggable="true"
                    vid="component-marker"
                    :position="position"
                    :events="{ dragend: dragEnd }"
            ></el-amap-marker>
        </el-amap>
        <div class="locate-list">
            <div>
                <Search v-model="searchInput" @blur="blur" placeholder="输入地址进行搜索" @search="getAround">
                    <div slot="left-icon">
                        <button slot="left-icon" @click="switchPanel('area')"
                                style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">
                            {{areaName}}
                        </button>
                    </div>
                </Search>

            </div>


            <div class="list-content">
                <CellGroup>
                    <Cell
                            v-for="(item, index) in list"
                            :key="index"
                            :size="radio==index?'large':''"
                            :label="item.address && item.address.toString()"
                            @click="itemClick(item.longitude, item.latitude,index)"
                    >
                        <div slot="title" :style="radio==index?'color:#228EFA':''">
                            <span>{{item.name}}</span>
                            <br/>
                            <span style="font-size:12px">{{item.address && item.address.toString()}}</span>
                        </div>
                        <Icon slot="right-icon" name="location-o" v-if="radio==index" size="20px"></Icon>
                    </Cell>
                </CellGroup>
            </div>
        </div>
        <AreaPanel :areas="areas" :show="areaPanel" @panel="switchPanel"/>
    </PopupPanel>
</template>

<script>
    import PopupPanel from "./PopupPanel";
    import Select from "@/components/Select";
    import AreaPanel from "@/components/AreaPanel";
    import {Cell, CellGroup, Col, Field, Icon, Row, Search} from "vant";
    import wx from "weixin-js-sdk";
    import http from "@/http";

    export default {
        components: {
            PopupPanel, Search, AreaPanel,
            CellGroup, Cell, Icon,
            Row, Col, Field,
            Select
        },
        props: {
            show: {type: Boolean, default: false},
            lng: {type: String, required: false},
            lat: {type: String, required: false},
            areaId: {type: String, required: false}
        },
        data() {
            return {
                center: [116.397024, 39.918396], //显示的中心
                position: [116.397024, 39.918396], //实际传输的值
                areas: [], areaPanel: false, areaName: '',
                searchInput: "",
                radio: -1,
                list: [],
                plugin: [
                    {
                        pName: "Geolocation"
                    }
                ]
            };
        },
        mounted() {
            // this.getLocation();
            // this.getAround();
            this.loadAreaTree(this.areaId)
            this.position = this.center = [this.lng, this.lat];
            this.getAround();
        },
        methods: {
            //所属区域
            blur() {
                window.scrollTo(0, 0);
            },
            panelClick(type, ok) {
                if (ok) {
                    this.$emit("panel", type, this.position);
                } else {
                    this.$emit("panel", type, [0, 0]);
                }
            },
            itemClick(lon, lat, index) {
                this.position = [lon, lat];
                this.center = this.position;
                this.radio = index;
            },
            mapClick(e) {
                const {lng, lat} = e.lnglat;
                this.position = [lng, lat];
                this.getAround();
            },
            dragEnd(e) {
                const {lon, lat} = e.lnglat;
                this.position = [lon, lat];
                this.getAround();
            },
            // 获取当前定位坐标
            getLocation() {
                const This = this;
                wx.getLocation({
                    success: function (res) {
                        const latitude = res.latitude; //纬度
                        const longitude = res.longitude; //经度
                        This.position = [longitude, latitude];
                        This.center = This.position;
                    },
                    cancel: function (res) {
                        alert("用户拒绝授权获取地理位置");
                    },
                    fail: function (res) {
                        alert(JSON.stringify(res));
                    }
                }); //end wx.getLocation
            },
            loadAreaTree(areaId) {
                http.tokiot.sys.area.v2.tree(areaId ? {id: areaId} : {})
                    .then(ret => {
                        if (ret) {
                            this.areaName = ret.name
                            this.areas = [ret]
                        }
                    })
            },
            switchPanel(type, data) {
                switch (type) {
                    case "area":
                        if (data && data !== "area") {
                            this.position = this.center = [data.lng, data.lat];
                            this.areaName = data.name
                        }
                        this.areaPanel = !this.areaPanel;
                        break;
                    default:
                        break;
                }
            },
            getAround() {
                const keywords = this.searchInput;
                const extensions = `all`;
                const sortrule = `weight`;
                this.radio = -1;
                const location = this.position[0] + "," + this.position[1];
                http.amap.getAround({location, keywords ,extensions,sortrule})
                    .then(res => {
                        console.log(`map`,res)
                        if (res.status === "1") {
                            const data = res.pois
                                .map(item => {
                                    const {name, address, district, location} = item;
                                    if (location.length > 0) {
                                        const position = location.split(",");
                                        const longitude = position[0];
                                        const latitude = position[1];
                                        return {name, address, district, longitude, latitude};
                                    }
                                })
                                .filter(item => {
                                    if (item !== undefined) return item;
                                });
                            console.info('list',data)
                            this.list = data;
                        }
                    })
            }
        },
        watch: {
            lng(newValue) {
                this.position = this.center = [this.lng, this.lat];
                this.getAround();
            },
            lat(newValue) {
                this.position = this.center = [this.lng, this.lat];
                this.getAround();
            },
            areaId(id) {
                this.loadAreaTree(id)
            },
        },
    };
</script>
<style lang="less" scoped>
    .amap-box {
        width: 100%;
        height: 180px;
    }

    .locate-list {
        display: flex;
        flex-direction: column;
        height: ~"calc(100% - 228px)";
        .list-content {
            height: ~"calc(100% - 45px)";
            overflow-y: scroll;
        }
    }
</style>
